export type JustifyProps = 'right' | 'left' | 'center' | 'space-between';
